module.exports = __webpack_public_path__ + "assets/img/pinpai-cp3.2e059fc9.png";